import React from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import keycloak from "./Keycloak"
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Container, createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import store from './app/store'
import {Provider} from "react-redux";
import {gmtpTheme} from "./themes/gmtpTheme";
import {SnackbarProvider} from "notistack";
import TopBar from "./components/TopBar";
import MtgCards from "./components/MtgCards";
import MtgCard from "./components/MtgCard";
import MtgInitData from "./components/MtgInitData";
import Cart from "./components/orders/Cart";
import Version from "./components/footer/Version";
import MtgSealed from "./components/MtgSealed";
import MtgSets from "./components/MtgSets"
import TestPage from "./components/test/TestPage";
import AlertDialog from "./components/dialogs/AlertDialog";
import Event from "./components/events/Event";
import Events from "./components/events/Events";
import Merch from "./components/merch/Merch";
import CartTest from "./components/test/CartTest";
import ReactGA from "react-ga4";
import MyCollection from "./components/collection/MyCollection";
import PrivateRoute from "./helpers/PrivateRoute";
import UserCollection from "./components/collection/UserCollection";
import Checkout from "./components/orders/Checkout";
import MtgOffers from "./components/MtgOffers";
import MtgAllOffers from "./components/MtgAllOffers";
import Order from "./components/orders/Order";
import MyOrders from "./components/orders/MyOrders";
import GeneralTerms from "./components/docs/GeneralTerms";
import PrivacyPolicy from "./components/docs/PrivacyPolicy";

function App() {

    const eventLogger = (event, error) => {
        console.log('onKeycloakEvent', event, error)
        switch (event) {
            case "onAuthSuccess":
                ReactGA.event({ category: "security", action: 'login'});
                break;
        }
    }

    const tokenLogger = (tokens) => {
//        console.log('onKeycloakTokens', tokens)
    }

    const theme = createTheme(gmtpTheme);
//    ReactGA.send({ hitType: "pageview", page: window.location.pathname});

    return (
        <ReactKeycloakProvider authClient={keycloak}
                               initOptions={{flow: 'hybrid'}}
                               onEvent={eventLogger}
                               onTokens={tokenLogger}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider>
                    <Provider store={store}>
                        <CssBaseline/>
                        <BrowserRouter basename={process.env.PUBLIC_URL}>
                            <MtgInitData/>
                            <TopBar/>
                            <AlertDialog/>
                            <Container maxWidth="xl">
                                <Routes>
                                    <Route path="/">
                                        {/*
                                        <Route index element={<AdvancedSearch/>}/>
                                        */}
                                        <Route index element={<MtgCards/>}/>
                                        <Route path="search" element={<MtgCards/>}/>
                                        <Route path="docs/terms" element={<GeneralTerms/>}/>
                                        <Route path="docs/privacy" element={<PrivacyPolicy/>}/>
                                        <Route path="cart">
                                            <Route index element={<Cart/>}/>
                                            <Route path="checkout" element={<Checkout/>}/>
                                        </Route>
                                        <Route path="offers" element={<MtgAllOffers/>}/>
                                        <Route path="sets">
                                            <Route index element={<MtgSets/>}/>
                                        </Route>
                                        <Route path="user/:user" element={<UserCollection/>}/>
                                        <Route path="user/compared/:user" element={<PrivateRoute><UserCollection/></PrivateRoute>}/>
                                        <Route path="account">
                                            <Route index element={<PrivateRoute><MyCollection/></PrivateRoute>}/>
                                            <Route path="collection" element={<PrivateRoute><MyCollection/></PrivateRoute>}/>
                                            <Route path="orders" element={<PrivateRoute><MyOrders/></PrivateRoute>}/>
                                            <Route path="orders/:id" element={<PrivateRoute><Order/></PrivateRoute>}/>
                                        </Route>
                                        <Route path="sealed/:id" element={<MtgSealed/>}/>
                                        <Route path=":set" element={<MtgCards/>}/>
                                        <Route path=":set/:no" element={<MtgCard/>}/>
                                        <Route path=":set/:no/:name" element={<MtgCard/>}/>
                                        <Route path=":set/:no/:name/:reverse" element={<MtgCard/>}/>

                                        <Route path="shop">
                                            <Route index element={<TestPage/>}/>
                                            <Route path="cart" element={<CartTest/>}/>
                                            <Route path="merch" element={<Merch/>}/>
                                            <Route path="events">
                                                <Route index element={<Events/>}/>
                                                <Route path="tolaria" element={<Event/>}/>
                                            </Route>
                                        </Route>

                                        <Route path="test" element={<TestPage/>}/>
                                    </Route>
                                </Routes>
                            </Container>
                        </BrowserRouter>
                    </Provider>
                    <Version/>
                </SnackbarProvider>
            </ThemeProvider>
        </ReactKeycloakProvider>
    );
}

export default App;
